import { Grid, Skeleton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { ManyEnvelops } from "../../../../assets/icons";
import { useAppSelector } from "../../../../custom-hooks/redux/redux";
import { MailInboxSummaryDTO } from "../../../../models/mail-inbox-summary/mail-inbox-summary-dto";
import { AUTHORIZATIONS } from "../../../../utils/constants/authorization-constants";

const UnprocessedOutgoingMailLink = ({
  customSummary,
  loading,
}: {
  customSummary: MailInboxSummaryDTO;
  loading: boolean;
  linkId: string;
}) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.manage_mail";
  const theme = useTheme();

  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);

  const canProcessOutgoing =
    currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanProcessOutgoing) &&
    !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanClassifyOutgoing) &&
    !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadOutgoing) &&
    !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanReadOutgoing) &&
    !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanClassifyIncoming) &&
    !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadIncoming) &&
    !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanReadIncoming);

  return canProcessOutgoing ? (
    loading ? (
      <Skeleton
        variant="rounded"
        width={"70%"}
        style={{ marginBottom: "2px" }}
      />
    ) : customSummary.unprocessedOutgoingMails > 0 ? (
      <Grid
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "5px",
          width: "100%",
        }}
      >
        <Grid
          style={{
            display: "flex",
            color: theme.palette.primary.main,
            justifyContent: "left",
            alignItems: "end",
            gap: "5px",
            width: "150px",
            margin: "3px 0px",
          }}
        >
          <ManyEnvelops style={{ width: "22px", height: "22px" }} />
          <Typography style={{ fontSize: "16px", lineHeight: "14px" }}>
            {customSummary.unprocessedOutgoingMails}
          </Typography>
          <Typography style={{ fontSize: "16px", lineHeight: "14px", color: theme.palette.text.primary }}>
            {`${t(`${tRP}.unprocessed`)}`}
          </Typography>
        </Grid>
      </Grid>
    ) : (
      <>
        <Grid
          style={{
            display: "flex",
            flexDirection: "column",
            color: theme.palette.success.main,
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
            width: "100%",
            margin: "3px 0px",
          }}
        >
          <Typography style={{ fontSize: "22px" }}>{`${t(`${tRP}.no_mails_to_process`)}`}</Typography>
          <Typography variant="body2">{"...Overview"}</Typography>
        </Grid>
      </>
    )
  ) : (
    <></>
  );
};
export default UnprocessedOutgoingMailLink;
